import * as React from 'react';
import {useState} from 'react';
import {odxIconSets} from "../../../OdxComponents/constants";
import OdxInputField from "../../../OdxComponents/NativeOdx/FormControls/Odx-InputField";

interface KeyFieldProps {
    keyString: string;
    idPrefix?: string;
}

const ApiKeyField: React.FC<KeyFieldProps> = ({keyString, idPrefix}) => {
    const [hidden, setHidden] = useState(true);
    const [copied, setCopied] = useState(false);
    const inputId = idPrefix ? `${idPrefix}-input` : 'api-key-field';

    const handleCopy = () => {
        navigator.clipboard.writeText(keyString);
        setCopied(true);
        // visual effects
        setTimeout(() => setCopied(false), 2000);
    };

    const handleReveal = () => {
        setHidden(!hidden);
    };

    return (
        <div className={`relative w-full mb-[10px] flex items-center`} id={idPrefix ? `${idPrefix}-container` : undefined}>
            <div className="flex-grow">
                <OdxInputField isRequired={false} id={inputId} label={""} value={keyString} hidden={hidden}
                               isDisabled={hidden}/>
            </div>
            <div className="flex-shrink-0 pb-7" style={{width: '18%'}}>
                <odx-icon-button
                    variant="ghost"
                    size="lg"
                    onClick={handleCopy}
                    id={idPrefix ? `OdxButton_${idPrefix}-copy-btn` : undefined}
                    icon={`${odxIconSets.core}::${copied ? 'check' : 'copy-content'}`}
                />
            </div>
            <div className="flex-shrink-0 pb-7" style={{width: '18%'}}>
                <odx-icon-button
                    variant="ghost"
                    size="lg"
                    onClick={handleReveal}
                    id={idPrefix ? `OdxButton_${idPrefix}-toggle-btn` : undefined}
                    icon={`${odxIconSets.core}::${hidden ? 'view-off' : 'view'}`}
                />
            </div>
        </div>
    );
};

export default ApiKeyField;
